import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react";
import { ReactNode } from "react";

const PermissionsSection = ({
  allPermissions,
  rolePermissions,
  onChange,
  disabled = false,
}: {
  allPermissions: any[];
  rolePermissions: any[];
  onChange: (perm: any, checked: boolean) => void;
  disabled?: boolean;
}) => {
  const grouped = allPermissions.reduce((acc: Record<string, any[]>, perm) => {
    const entity = perm.entity;
    if (!acc[entity]) acc[entity] = [];
    acc[entity].push(perm);
    return acc;
  }, {});

  const hasPermission = (permName: string) => {
    return rolePermissions?.some((perm) => perm.name === permName);
  };

  interface CardProps {
    title: ReactNode;
    cardContent: ReactNode;
  }

  const CardComponent: React.FC<CardProps> = ({ title, cardContent }) => {
    return (
      <div
        style={{
          border: "1px solid #ddd",
          borderRadius: 8,
          padding: "16px",
          width: "100%",
          marginTop: "10px",
        }}
      >
        <header style={{ borderBottom: "1px solid #ddd", width: "100%" }}>
          {title}
        </header>
        <main style={{ marginTop: "20px" }}>{cardContent}</main>
      </div>
    );
  };

  return (
    <>
      {Object.entries(grouped).map(([entityName, perms]) => (
        <CardComponent
          key={entityName}
          title={
            <Typography variant="h5" fontWeight={500}>
              {entityName}
            </Typography>
          }
          cardContent={
            <FormGroup row>
              {perms.map((perm) => (
                <FormControlLabel
                  key={perm.id}
                  control={
                    <Checkbox
                      checked={hasPermission(perm.name)}
                      onChange={(e) => onChange(perm, e.target.checked)}
                      disabled={disabled}
                    />
                  }
                  label={perm.description}
                />
              ))}
            </FormGroup>
          }
        />
      ))}
    </>
  );
};

export default observer(PermissionsSection);
